import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {FooterBar} from 'shells/modal/footer-bar';
import {ModalBody} from 'shells/typography/modal-body';

import type {SentOutreachItem} from './send-marketing-outreach-modal';

import styles from './sending-confirmation-page.module.css';

type Props = {
    onClose: () => void;
    sentOutreachItem: SentOutreachItem;
    numRecipients: number;
};

export function SendingConfirmationPage(props: Props) {
    const {onClose, sentOutreachItem, numRecipients} = props;

    const isDripSequence = sentOutreachItem.outreachType === 'DripSequence';
    const messageType = sentOutreachItem.outreachType === 'Broadcast' ? 'broadcast' : 'edition';

    return (
        <div className={styles['sending-confirmation-page']}>
            <div className={styles['content-container']}>
                <div className={styles['illustration-container']}>
                    {isDripSequence ? (
                        <Illustration src='drip-sequence-doodle' />
                    ) : (
                        <div className={styles['email-illustration']}>
                            <Illustration src='email-airplane-white' />
                        </div>
                    )}
                </div>
                <div className={styles['text-container']}>
                    <StackLegacy spacing={8}>
                        <div className={styles['title-text']}>
                            {isDripSequence ? 'Good news!' : 'Off it goes!'}
                        </div>
                        <ModalBody>
                            {isDripSequence
                                ? `${numRecipients} recipient${
                                      numRecipients === 1 ? ' has' : 's have'
                                  } been added to your drip sequence`
                                : `This ${messageType} ${
                                      sentOutreachItem.sentFromDraft
                                          ? 'is on its way'
                                          : 'has been copied and sent'
                                  }`}
                        </ModalBody>
                        {!isDripSequence ? (
                            <div className={styles['description-text']}>
                                Sending may take a few minutes, so visit this message soon to view
                                engagement metrics.
                            </div>
                        ) : undefined}
                    </StackLegacy>
                </div>
            </div>
            <Link
                // @ts-expect-error
                as={RoutedLink}
                to={sentOutreachItem.htmlUrlPath}
                variant='button-primary'
                size='big'
            >
                View {sentOutreachItem.name}
            </Link>
            <FooterBar
                right={
                    <Button onClick={onClose} variant='secondary' size='big'>
                        Done
                    </Button>
                }
            />
        </div>
    );
}
